import Login from './components/Login.vue';
import CreatePlan from './components/CreatePlan.vue';
import Settings from './components/Settings.vue';
import Plan from './components/Plan.vue';
import Redeem from './components/Redeem.vue';
import TicketView from './components/TicketView.vue';
import TicketList from './components/TicketList.vue';
import firebase from 'firebase';

export const routes = [
    { path: '/login/', component: Login},
    { path: '/', component: CreatePlan, beforeEnter:beforeEnter},
    { path: '/settings/', component: Settings, beforeEnter:beforeEnter},
    { path: '/plan/:key', component: Plan, beforeEnter:beforeEnter},
    { path: '/redeem/', component: Redeem },
    { name:'ticket', path: '/ticket/:key', component: TicketView,beforeEnter:bgDark },
    { name:'ticketList',path: '/ticketlist/:key', component: TicketList },
];

function beforeEnter(to,from,next){
    firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
            console.log('User has signed in: ');
            next();
        } else {
            console.log('No user has signed in.');
            next('/login');
        }
    });
}

function bgDark(to, from, next){
    document.body.className = 'bg-dark';
    next();
}